import { Avatar, Breadcrumb, Button, Image, message, Modal, Popconfirm, Tag } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useParams,useNavigate } from 'react-router-dom'
import { SERVER_ADDRESS } from '../../Config/Config';
import { UserOutlined } from '@ant-design/icons';

const ViewUser = () => {
    const {id} = useParams();
    const [user,setUser] = useState({});
    const [isModalOpen,setIsmodalOpen] = useState(false)
    const navigate = useNavigate();

    const fetchUser = async()=>{
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/singleUser`,{
                userId:id
            });
            const data = response.data.data
            setUser(data)
        } catch (error) {
            console.log(error);
            message.error({content:"Oops! something went wrong"})
        }
    }

    useEffect(()=>{
        fetchUser();
    },[])

    const breadcrumbItems = [
        {
            path: "/dashboard",
            title: "Home",
        },
        {
            path: "/underVerification",
            title: "Under Verify",
        },
    ];

    const dobToAge = (dob)=>{
        const now = Date.now();
        const difference = now - dob;
        const age = difference / (1000 * 60 * 60 * 24 * 365.25)
        return Math.floor(age)
    }

    const formattedDate = (time) => {
        let date = new Date(parseInt(time))
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        let day = String(date.getDate()).padStart(2, '0');

        return `${day}/${month}/${year}`
    };

    const handleCancel = ()=>{
        setIsmodalOpen(false)
    }
    const handleModal = ()=>{
        setIsmodalOpen(true)
    }

    const handleVerification = async(id,type,email,name) =>{   
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/verifyOrReject`,{
                type,
                id,
                email,
                name
            })
            if(response.status === 200){
                navigate('/underVerification');
                message.success({content:"User verified",duration:2})
            }
        } catch (error) {
            message.error({content:"Something went wrong",duration:2})
        }
    }

  return (
    <>
    <div className='' style={{marginTop:'4rem'}} >
        <div className='d-flex flex-row justify-content-between' >
        <h3>{user.name}</h3>
        <Breadcrumb>
            {breadcrumbItems.map((item,index)=>(
                <Breadcrumb.Item key={index} >
                    <Link to={item.path}>{item.title}</Link>
                </Breadcrumb.Item>
            ))}
        </Breadcrumb>
        </div>
        <div className='mt-5 p-3 d-flex flex-row ' style={{backgroundColor:"white",height:"100vh"}} >
            <div style={{display:"flex",flexDirection:"column",gap:'1rem'}} >
                <h4 >Basic Details</h4>
                <div style={{display:"flex",flexDirection:"column",gap:"1rem",padding:"2rem"}} >
                    <div className='d-flex flex-row gap-4' >
                    {user?.photo?.length > 0 ? <Avatar onClick={()=>handleModal()} src={user.photo[0]} size={84} style={{cursor:"pointer"}} /> 
                    : <Avatar icon={<UserOutlined />} size={84} style={{cursor:"pointer"}} /> }
                    </div>
                    <div className="d-flex flex-row gap-4">
                    <h5>Id :</h5>
                    <h5>{user.id}</h5>
                    </div>
                    <div className="d-flex flex-row gap-4">
                    <h5>Name :</h5>
                    <h5>{user.name}</h5>
                    </div>
                    <div className="d-flex flex-row gap-4">
                    <h5>Gender :</h5>
                    <h5>{user?.gender === '1' ? <Tag color='blue' >Groom</Tag> : <Tag color='magenta' >Bride</Tag> }</h5>
                    </div>
                    
                    <div className="d-flex flex-row gap-4">
                    <h5>DOB :</h5>
                    <h5>{formattedDate(user.dob)}</h5><span>({dobToAge(user.dob)} Years old)</span>
                    </div>
                    
                    <div className="d-flex flex-row gap-4">
                    <h5>Email :</h5>
                    <h5>{user.email}</h5>
                    </div>
                    
                    <div className="d-flex flex-row gap-4">
                    <h5>Phone :</h5>
                    <h5>{user.phone}</h5>
                    </div>
                    
                    <div className="d-flex flex-row gap-4">
                    <h5>Device Type :</h5>
                    <h5>{user.device_type}</h5>
                    </div>
                    
                    <div className="d-flex flex-row gap-4">
                    <h5>Active Status :</h5>
                    <h5>{user.active_status === 1 ? <Tag color='green' >Active</Tag> : <Tag color='red' >Inactive</Tag> }</h5>
                    </div>
                </div>
            </div>
            <div style={{width:"2px",backgroundColor:"#ccc",height:"100%", marginLeft:"12rem"}} ></div>
            <div style={{ display: 'flex', flexDirection: "column", gap: '1rem' }}>
                <h4 style={{ marginLeft: '1rem' }}>Aadhar Documents</h4>
                <div style={{ padding: '2rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <div style={{ display: "flex", flexDirection: 'column', gap: '0.8rem' }}>
                        <h6>Aadhar Image:</h6>
                        <div style={{ width: '20rem', height: "10rem", overflow: "hidden"}}>
                            <Image 
                                src={user.aadhar_img} 
                                style={{ 
                                    // width: "100%", 
                                    // height: "100%", 
                                    objectFit: "cover" // Ensures the image fills the container while maintaining aspect ratio
                                }} 
                            />
                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: 'column', gap: '0.8rem' }}>
                        <h6>Aadhar Num:</h6>
                        <h5>{user.aadhar_num}</h5>
                    </div>
                </div>
            </div>

        </div>
        <div className='d-flex flex-row gap-4 justify-content-center align-items-center' style={{backgroundColor:"white"}} >
            <Popconfirm okText='yes' placement='top' cancelText='no' onConfirm={(()=>handleVerification(user.id,'1',user.email,user.name))} description={'Are You Sure Want To verify the User ?'} >
            <Button style={{width:'6rem',height:"2.5rem"}} type='primary' >Verify</Button>
            </Popconfirm>
            <Popconfirm okText='yes' placement='top' onConfirm={(()=>handleVerification(user.id,'2',user.email,user.name))} cancelText='no' description={'Are You Sure Want To Reject the User ?'} >
            <Button style={{width:'6rem',height:"2.5rem"}} color='danger' variant='solid' >Reject</Button>
            </Popconfirm>
        </div>
    </div>
    <Modal open={isModalOpen} onCancel={handleCancel} width={1200} footer={false} >
        <div style={{display:'flex',flexWrap:'wrap',gap:'2rem',justifyContent:'center'}} >
            <Image.PreviewGroup>
                {user.photo && user.photo.map((p,index)=>(
                    <div key={index} style={{textAlign:'center'}} >
                        <div style={{alignItems:'center',display:'flex',height:300,background:'black'}} >
                            <Image src={p} width={200}  />
                        </div>
                    <p style={{marginTop:'5px',fontWeight:'bold'}}>{index + 1}</p>
                </div>
            ))}
            </Image.PreviewGroup>
        </div>
    </Modal>
    </>
  )
}

export default ViewUser